export default "__VITE_ASSET__DTTdlb1z__"